"use client";

import { FC, PropsWithChildren, useEffect, useState } from "react";
import styles from "./LoadingAnimation.module.scss";

type LoadingTextProps = PropsWithChildren<{
    afterFadeOut: () => void;
}>;

const LoadingText: FC<LoadingTextProps> = ({ afterFadeOut, children }) => {
    const [className, setClassName] = useState(styles["initial-state"]);

    useEffect(() => {
        setClassName(styles["fade-in"]);
    }, []);

    const handleAnimationEnd = (
        event: React.AnimationEvent<HTMLSpanElement>,
    ) => {
        const element = event.currentTarget;
        if (element.className.includes(styles["fade-out"])) {
            setClassName(styles["fade-in"]);
            afterFadeOut();
        }

        if (element.className.includes(styles["fade-in"])) {
            setClassName(styles["fade-out"]);
        }
    };

    return (
        <span
            aria-hidden="true"
            className={className}
            onAnimationEnd={handleAnimationEnd}
        >
            {children}
        </span>
    );
};

export default LoadingText;
